<div class="field" [formGroup]="formGroup" [ngClass]="{'horizontal': labelPosition == 'left'}">
    <label class="field__title" [for]="id">{{label ? label : ""}}</label>
    <input [id]="id" [placeholder]="placeholder ? placeholder : ''" type="date" [formControlName]="id"
        [ngClass]="[formGroup.get(id)!.errors && formGroup.get(id)!.touched ? 'error' : '']" />

    <form-error [id]="id" [formGroup]="formGroup"></form-error>
</div>
